export function getBuildingParam(building, flat) {
  const param = {}

  if (building?.value) {
    param.building = building.value.toString()
  }

  if (flat?.value) {
    param.flat = flat.value.toString()
  }

  return param
}
